<template>
  <AdminLayout>
    <div class="space-y-6">
      <div class="flex items-center justify-between">
        <h1 class="text-2xl font-heading font-bold text-mifo-primary">Neues Produkt</h1>
        <div class="space-x-2">
          <button class="btn-primary" @click="save">Erstellen</button>
        </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div class="lg:col-span-2 space-y-6">
          <div class="card">
            <label class="block text-sm font-medium text-gray-700 mb-1">Name</label>
            <input class="input-field" v-model="form.name" />
          </div>
          <div class="card">
            <label class="block text-sm font-medium text-gray-700 mb-1">Beschreibung</label>
            <div id="editor" class="border rounded-md"></div>
          </div>
        </div>
        <div class="space-y-6">
          <div class="card">
            <label class="block text-sm font-medium text-gray-700 mb-1">Preis (EUR)</label>
            <input type="number" min="0" class="input-field" v-model.number="priceEuros" />
          </div>
          <div class="card">
            <label class="block text-sm font-medium text-gray-700 mb-1">Mehrwertsteuer (%)</label>
            <input type="number" min="0" class="input-field" v-model.number="form.vatRate" />
          </div>
          <div class="card">
            <label class="block text-sm font-medium text-gray-700 mb-1">Versandkosten (EUR)</label>
            <input type="number" min="0" step="0.01" class="input-field" v-model.number="sendingCostsEuros" placeholder="0.00" />
            <p class="text-xs text-gray-500 mt-1">Leer lassen wenn keine Versandkosten anfallen</p>
          </div>
          <div class="card">
            <label class="block text-sm font-medium text-gray-700 mb-2">Produkttyp</label>
            <div class="space-y-2">
              <label class="flex items-center gap-2 text-sm text-gray-700">
                <input type="radio" name="productType" :value="false" v-model="form.allowMultiplePerOrder" />
                Einzelauswahl (1 Stück)
              </label>
              <label class="flex items-center gap-2 text-sm text-gray-700">
                <input type="radio" name="productType" :value="true" v-model="form.allowMultiplePerOrder" />
                Mehrfachauswahl (Anzahl wählbar)
              </label>
            </div>
          </div>
          <div class="card">
            <div class="flex items-center justify-between">
              <span class="text-sm text-gray-700">Aktiv</span>
              <input type="checkbox" v-model="form.isActive" />
            </div>
          </div>
          <div class="card">
            <div class="flex items-center justify-between">
              <span class="text-sm text-gray-700">Als Add-on verfügbar</span>
              <input type="checkbox" v-model="form.isAddonEnabled" />
            </div>
          </div>
          <div class="card">
            <label class="block text-sm font-medium text-gray-700 mb-1">Sortierreihenfolge</label>
            <input type="number" min="0" class="input-field" v-model.number="form.sortOrder" placeholder="0" />
            <p class="text-xs text-gray-500 mt-1">Niedrigere Zahlen werden zuerst angezeigt</p>
          </div>
        </div>
      </div>
    </div>
  </AdminLayout>
</template>

<script>
import { reactive, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/utils/axios'
import AdminLayout from '@/components/Layout/AdminLayout.vue'

export default {
  name: 'ProductCreate',
  components: { AdminLayout },
  setup() {
    const router = useRouter()
    const form = reactive({ name: '', priceCents: 0, vatRate: 19, isActive: false, isAddonEnabled: false, allowMultiplePerOrder: true, descriptionHtml: '', sendingCostsCents: null, sortOrder: 0 })
    const priceEuros = ref(0)
    const sendingCostsEuros = ref(0)
    let quill

    const save = async () => {
      try {
        form.priceCents = Math.round((priceEuros.value || 0) * 100)
        form.sendingCostsCents = sendingCostsEuros.value ? Math.round((sendingCostsEuros.value || 0) * 100) : null
        form.descriptionHtml = quill ? quill.root.innerHTML : form.descriptionHtml
        const { data } = await api.post('/products', form)
        router.push(`/herzbeben/products/${data.id}`)
      } catch (e) {
        console.error('Fehler beim Erstellen des Produkts:', e)
        alert(e?.response?.data?.error || 'Erstellen fehlgeschlagen')
      }
    }

    onMounted(async () => {
      const Quill = (await import('quill')).default
      await import('quill/dist/quill.snow.css')
      quill = new Quill('#editor', { theme: 'snow' })
    })

    return { form, priceEuros, sendingCostsEuros, save }
  }
}
</script>

